export const PreAccountInfo = ({ loginType, email }: { loginType: string; email: string }) => {
  const snsTypes = {
    NAVER: '네이버',
    APPLE: 'Apple',
    KAKAO: '카카오'
  };

  const snsImages = {
    NAVER: '/images/symbols/sns-circle-naver.svg',
    APPLE: '/images/symbols/sns-circle-apple.svg',
    KAKAO: '/images/symbols/sns-circle-kakao.svg'
  };

  switch (loginType) {
    case 'NAVER':
    case 'KAKAO':
    case 'APPLE':
      return (
        <>
          <p className="body-14 text-left text-gray-700">
            결과는 신청했던 계정으로만 확인이 가능해요. 비즈넵 환급 서비스에서 아래 로그인 방법을 통해 확인해주세요.
          </p>
          <div className={'flex flex-col gap-y-0.5'}>
            <p>로그인 방법</p>
            <p className={'flex items-center gap-x-[5px]'}>
              <img src={snsImages[loginType]} alt={loginType} width={20} height={20} />
              <span className={'font-bold'}>{`${snsTypes[loginType]} 계정으로 로그인`}</span>
            </p>
          </div>
          <div className={'flex flex-col gap-y-0.5'}>
            <p>로그인 계정(참고)</p>
            <p className={'font-bold'}>{email}</p>
          </div>
        </>
      );
    case 'REFUND_TOSS':
      return (
        <>
          <p className="body-14 text-left text-gray-700">
            결과는 신청했던 토스 앱에서
            <br />
            아래 접속 경로로 확인해주세요.
          </p>
          <div className={'flex flex-col gap-y-0.5'}>
            <p>접속 경로</p>
            <p className={'font-bold'}>토스 앱 → 전체 메뉴 → 사업자 환급받기</p>
          </div>
        </>
      );
    case 'EMAIL':
    default:
      return (
        <>
          <p className="body-14 text-left text-gray-700">
            이메일로 가입한 계정으로 신청하셨는데, 현재 이메일로 로그인을 할 수 없어 확인이 필요하시면 고객센터에 문의 바랍니다.
          </p>
          <div className={'flex flex-col gap-y-0.5'}>
            <p>이메일 주소</p>
            <p className={'font-bold'}>{email}</p>
          </div>
        </>
      );
  }
};
